import script from "./InputText.vue?vue&type=script&setup=true&lang=js"
export * from "./InputText.vue?vue&type=script&setup=true&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=ef66d908&lang=css"

const __exports__ = script;

export default __exports__